import React from "react";
import { Button } from "./ui/button";
import { Scissors, Check, X, Loader2, NotebookPen } from "lucide-react";

/** Live list of the voice trim-notes session (inside Buddy's balloon). */
export function BuddyTrimCard({ session, t, busy, onFinish, onCancel, onOpenNotes, onDismiss }) {
  if (!session) return null;
  const items = session.items || [];
  const done = session.status === "done";
  const title = [session.customer_name, session.job_number ? `#${session.job_number}` : ""].filter(Boolean).join(" · ");
  return (
    <div data-testid="buddy-trim-card" className="rounded-xl border-2 border-emerald-400/60 bg-emerald-50 dark:bg-emerald-950/30 px-3 py-2 space-y-1.5">
      <div className="flex items-center gap-1.5">
        <Scissors className="h-3.5 w-3.5 text-emerald-700 dark:text-emerald-300 shrink-0" />
        <span className="text-[11px] font-semibold text-emerald-700 dark:text-emerald-300 uppercase tracking-wide truncate flex-1" data-testid="buddy-trim-title">
          {done ? t("buddy_trim_saved") : t("buddy_trim_title")}{title ? ` · ${title}` : ""}
        </span>
        <span className="text-[11px] tabular-nums text-muted-foreground shrink-0" data-testid="buddy-trim-count">{items.length}</span>
      </div>
      {items.length === 0 && <div className="text-[12px] text-muted-foreground">{t("buddy_trim_empty")}</div>}
      {items.map((it) => (
        <div key={it.n} className="flex items-start gap-1.5 text-[12px]" data-testid="buddy-trim-item">
          <span className="font-semibold tabular-nums shrink-0">{it.n}.</span>
          <div className="min-w-0 flex-1">
            <div className="truncate">
              <span className="font-medium">{[it.location, it.label].filter(Boolean).join(" ") || "—"}</span>
              <span className="text-muted-foreground"> · {it.kind_label || "?"}</span>
            </div>
            <div className="font-mono-plex font-semibold text-emerald-700 dark:text-emerald-300 break-words">{it.value || "?"}</div>
            {!done && it.missing?.length > 0 && (
              <div className="text-[11px] text-amber-700 dark:text-amber-300">{t("buddy_trim_missing")}: {it.missing.map((m) => t(`trim_field_${m}`)).join(", ")}</div>
            )}
            {it.note && <div className="text-[11px] text-muted-foreground italic truncate">{it.note}</div>}
          </div>
        </div>
      ))}
      <div className="flex gap-1.5 pt-0.5">
        {done ? (
          <>
            <Button data-testid="buddy-trim-dismiss" size="sm" variant="outline" className="h-8 text-xs flex-1" onClick={onDismiss}>
              <X className="h-3.5 w-3.5 mr-1" />{t("close")}
            </Button>
            <Button data-testid="buddy-trim-open-notes" size="sm" className="h-8 text-xs flex-1" onClick={onOpenNotes}>
              <NotebookPen className="h-3.5 w-3.5 mr-1" />{t("buddy_measure_open_notes")}
            </Button>
          </>
        ) : (
          <>
            <Button data-testid="buddy-trim-cancel" size="sm" variant="outline" className="h-8 text-xs flex-1" disabled={busy} onClick={onCancel}>
              <X className="h-3.5 w-3.5 mr-1" />{t("buddy_cancel")}
            </Button>
            <Button data-testid="buddy-trim-finish" size="sm" className="h-8 text-xs flex-1" disabled={busy || items.length === 0} onClick={onFinish}>
              {busy ? <Loader2 className="h-3.5 w-3.5 mr-1 animate-spin" /> : <Check className="h-3.5 w-3.5 mr-1" />}{t("buddy_measure_finish")}
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
